<script setup>
import { useRoute, useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import EmptyStateLayout from 'dashboard/components-next/EmptyStateLayout.vue';
import Button from 'dashboard/components-next/button/Button.vue';

const { t } = useI18n();
const route = useRoute();
const router = useRouter();

const setupVoiceChannel = () => {
  router.push({
    name: 'settings_inbox_new',
    params: { accountId: route.params.accountId },
  });
};
</script>

<template>
  <section
    class="flex h-full w-full flex-col overflow-hidden bg-auth-canvas text-auth-text dark:bg-auth-canvas-dark dark:text-auth-text-dark"
  >
    <header
      class="sticky top-0 z-20 shrink-0 border-b border-auth-border bg-auth-canvas/95 px-3 dark:border-auth-border-dark dark:bg-auth-canvas-dark/95 sm:px-5 lg:px-6"
    >
      <div class="mx-auto w-full max-w-6xl py-4 sm:py-5">
        <h1
          class="text-xl font-semibold tracking-[-0.025em] text-auth-text dark:text-auth-text-dark sm:text-2xl"
        >
          {{ t('CALLS_PAGE.HEADER') }}
        </h1>
      </div>
    </header>
    <main class="flex-1 overflow-y-auto px-3 sm:px-5 lg:px-6">
      <div class="mx-auto flex min-h-full w-full max-w-6xl pb-6 pt-3 sm:pt-4">
        <div
          class="min-h-[30rem] w-full overflow-hidden rounded-xl border border-dashed border-auth-border bg-auth-surface/60 dark:border-auth-border-dark dark:bg-auth-surface-dark/60"
        >
          <EmptyStateLayout
            :title="t('CALLS_PAGE.SETUP.TITLE')"
            :subtitle="t('CALLS_PAGE.SETUP.SUBTITLE')"
            :show-backdrop="false"
            :action-perms="['administrator']"
            class="min-h-[30rem] [&>div]:!max-h-none [&>div>div]:!justify-center [&>div>div]:!pb-0 [&>div>div>div]:!mt-0 [&_h2]:!text-2xl [&_h2]:!font-semibold [&_h2]:!tracking-[-0.025em] [&_h2]:!text-auth-text dark:[&_h2]:!text-auth-text-dark [&_p]:!text-sm [&_p]:!leading-6 [&_p]:!tracking-normal [&_p]:!text-auth-muted dark:[&_p]:!text-auth-muted-dark"
          >
            <template #actions>
              <Button
                :label="t('CALLS_PAGE.SETUP.ACTION')"
                icon="i-lucide-plus"
                class="!rounded-xl !bg-auth-action !px-4 !text-white hover:!bg-auth-action-hover focus-visible:!outline focus-visible:!outline-2 focus-visible:!outline-offset-2 focus-visible:!outline-auth-action dark:!bg-auth-accent dark:!text-auth-brand dark:hover:!bg-auth-accent-hover dark:focus-visible:!outline-auth-accent"
                @click="setupVoiceChannel"
              />
            </template>
          </EmptyStateLayout>
        </div>
      </div>
    </main>
  </section>
</template>
